class InfiniteScroll {
  constructor() {
    this.bindElements();
    this.isLoading = false;
    this.initObserver();
    this.initEventListeners();
  }
  bindElements() {
    this.productList = document.querySelector('.product-list');
    this.loadMoreButton = document.getElementById('load-more');
  }
  initObserver() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadMore();
        }
      });
    });
    if (this.loadMoreButton) {
      this.observer.observe(this.loadMoreButton);
    }
  }
  initEventListeners() {
    window.addEventListener('facet:rendered', () => {
      this.rebindElements();
    });
  }
  rebindElements() {
    this.bindElements();
    if (this.loadMoreButton) {
      this.observer.disconnect();
      this.initObserver();
    }
  }
  async loadMore() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.addLoadingClass();
    const nextUrl = this.loadMoreButton.dataset.url;
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProductsContainer = doc.querySelector('.product-list__inner');
      if (newProductsContainer) {
        const newProducts = newProductsContainer.children;
        const currentProductsContainer = this.productList.querySelector('.product-list__inner');
        if (currentProductsContainer) {
          this.appendNewProducts(Array.from(newProducts), currentProductsContainer);
        } else {
          console.error('Product container not found');
        }
      } else {
        console.error('No new products found in the response');
      }
      this.updateLoadMoreButton(doc);
      window.dispatchEvent(new CustomEvent('productsLoadedGlobal'));
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.isLoading = false;
      this.removeLoadingClass();
    }
  }
  addLoadingClass() {
    if (this.loadMoreButton && this.isLoading) {
      this.loadMoreButton.classList.add('loading');
    }
  }
  removeLoadingClass() {
    if (this.loadMoreButton && !this.isLoading) {
      this.loadMoreButton.classList.remove('loading');
    }
  }
  appendNewProducts(newProducts, container) {
    newProducts.forEach(product => {
      product.style.opacity = '0';
      product.style.transform = 'translateY(20px)';
      container.appendChild(product);

      // Trigger reflow
      product.offsetHeight;

      // Animate new product
      product.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      product.style.opacity = '1';
      product.style.transform = 'translateY(0)';
    });
  }
  updateLoadMoreButton(doc) {
    const newPagination = doc.querySelector('.pagination');
    if (newPagination) {
      const newLoadMoreButton = newPagination.querySelector('#load-more');
      if (newLoadMoreButton) {
        this.loadMoreButton.dataset.url = newLoadMoreButton.dataset.url;
      } else {
        this.loadMoreButton.remove();
      }
    } else {
      this.loadMoreButton.remove();
    }
  }
}

// Initialize infinite scroll when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
});